import { getRouteApi } from '@tanstack/react-router';
import { signInWithCustomToken, signInWithPopup, signOut } from 'firebase/auth';
import { auth, googleProvider, useAuth } from '@discovr/common';
import { members } from '@discovr/api';
import { InviteAcceptPage } from '@discovr/ui';

const inviteRoute = getRouteApi('/invite');

export default function BrandInviteAcceptPage() {
  const { token } = inviteRoute.useSearch();
  const { user, loading: authLoading } = useAuth();

  const signInWithInviteToken = async (customToken: string) => {
    // Clear out any pre-existing session in this browser first — otherwise
    // the old account can remain the shared IndexedDB "current user" and
    // reappear on refresh instead of the account that just signed up.
    await signOut(auth).catch(() => {});
    await signInWithCustomToken(auth, customToken);
  };

  return (
    <InviteAcceptPage
      token={token}
      verifyFn={(token) => members.verifyInvite(token)}
      acceptFn={(body) =>
        members.acceptInvite({
          token: body.token,
          password: body.password,
          first_name: body.first_name ?? '',
          last_name: body.last_name ?? '',
        })
      }
      orgNameKey="brand_name"
      successRedirect="/start"
      currentUserEmail={authLoading ? undefined : (user?.email ?? null)}
      onSignOutCurrentUser={() => signOut(auth)}
      signInWithToken={signInWithInviteToken}
      onGoogleAccept={async () => {
        const result = await signInWithPopup(auth, googleProvider);
        const idToken = await result.user.getIdToken();
        // Sign out of the popup session immediately — AuthProvider's
        // onAuthStateChanged gate would otherwise race /auth/login against a
        // users row that doesn't exist yet (it's only created by the BE call
        // below, after it verifies the token's email matches the invite).
        await signOut(auth).catch(() => {});
        const accepted = await members.acceptInviteGoogle({ token: token ?? '', id_token: idToken });
        await signInWithInviteToken(accepted.firebase_custom_token);
      }}
    />
  );
}
